import { render, staticRenderFns } from "./QrCodeData.vue?vue&type=template&id=54bc078c&scoped=true&"
import script from "./QrCodeData.vue?vue&type=script&lang=js&"
export * from "./QrCodeData.vue?vue&type=script&lang=js&"
import style0 from "./QrCodeData.vue?vue&type=style&index=0&id=54bc078c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc078c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow,VSimpleTable,VSpacer})
